    <div class="modal" id="paretoModal" tabindex="-1" role="dialog" aria-labelledby="expandTit" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content iom-modewhite">
          <div class="modal-header">
            <h5 class="modal-title" id="">Word Count Pareto</h5>
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="closeExpand()">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <app-expandtree-chart [GraphData]="doughnutData"></app-expandtree-chart> -->
            <div class="justify-content-center align-items-center">
              <div *ngIf='wordCloudDataLength > 0' id="paretoChartSecond">    
                <app-paretoexp-chart [GraphData]="wordCloudData" [versionId]="VersionId" [wordlength]=wordLength
                [category]="CategoryId" [subcategory]="SubCategoryId" [containerID]="paretoChartIdSecond" [paretoExpand]="isParetoExpand"  (subPareto)="subParetoHandler($event)">
              </app-paretoexp-chart>
              </div>
              <div class="" id="expdrillPareto">
                <div class="modal-header exp_subparetotitle">
                  <h5 class="modal-title" id="">Word Repeat Pattern Pareto Detail Analysis for -<span class="sub-highlight-text">
                    {{SubParetName}}</span></h5>
                </div> 
                      <div class="card-body sub-pareto-height">
                        <div class="" id="exp_pareto_sub"></div>
                      </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<div class="row myw-grid">
  <div class="col d-flex">
    <div class="card iom-card">
      <div class="card-header">
        <h4 class="card-title pt-2">Select Word Count</h4>
      </div>
      <div class="card-body">
        <div class="form-group res-range">
          <input id="wordlen" type="range" class="myw-range" min="1" max="10" value="1"
            (input)="changeNgram($event.target.value)" [formControl]="inputSlider">
          <div class="d-flex justify-content-between res-range-label">
            <span>1</span>
            <span>2</span>
            <span>3</span>
            <span>4</span>
            <span>5</span>
            <span>6</span>
            <span>7</span>
            <span>8</span>
            <span>9</span>
            <span>10</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--1 -->
<div *ngIf='TextcategoryOrSubcategoryName != null' class="text-analysis-category">
  <div><strong class="fs-16 ml-1">{{TextcategoryOrSubcategoryName}}</strong> - <strong
      class="fs-16 ml-1">{{TextTicketCount}} Tickets</strong></div>
</div>
<div class="row myw-grid">
  <div class="col-12 col-lg-6 d-flex" id="wordcloudExpand">
    <div class="card iom-card">
      <div class="card-header">
        <h4 id="wordcloudexpandText" class="card-title pt-2">Word Cloud</h4>
        <button id="closeWordCloud" type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="closeExpandWord()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="card-body" id="wordcloudContent">
        <div *ngIf='wordCloudDataLength > 0' id="containerwordCloud">
          <app-word-chart [ContainerId]="containerwordCloud" [GraphData]="wordCloudData" [wordlength]=ngramValue></app-word-chart>
        </div>
        <div class="d-flex justify-content-end fs-12 myw-500">
          <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#wordCloudModal" (click)="expandWordCloud()">Expand</a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-6 d-flex">
    <div class="card iom-card">
      <div class="card-header">
        <h4 class="card-title pt-2">Word Count Pareto</h4>
      </div>
      <div class="card-body">
        <div *ngIf='wordCloudDataLength > 0' id="paretoChartMain">
          <app-pareto-chart [GraphData]="wordCloudData" [versionId]="VersionId" [wordlength]=wordLength
            [category]="CategoryId" [subcategory]="SubCategoryId" [containerID]="paretoChartId" (subPareto)="subParetoHandler($event)">
          </app-pareto-chart>
        </div>
        <div class="d-flex justify-content-end fs-12 myw-500">
          <a href="javascript:;" data-bs-toggle="modal"
          data-bs-target="#paretoModal" (click)="ExpandParetoChart()">Expand</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div id="wordCloudOverlay"></div>
<!-- 2-->
<div class="row myw-grid" id="drillPareto">
  <div class="col d-flex">
    <div class="card iom-card">
      <div class="card-header">
        <h4 class="card-title pt-2">Word Repeat Pattern Pareto Detail Analysis for -<span class="highlight-text">
            {{SubParetName}}</span></h4>
      </div>
      <div class="card-body sub-pareto-height">
        <div class="pareto_sub" id="pareto_sub"></div>
      </div>
    </div>
  </div>
</div>
<!-- 3 -->
<div class="row myw-grid" *ngIf="ticketDescRowLength > 0 ">
  <div class="col">
    <div class="card iom-card table-responsive iom-table-grid">
      <div id="textAnalysisDesc">

        <div class="card-body" id="container_ticketdesc">
          <div class="displayFlex search-tickets">
            <div class="text-secondary fs-12 ticketNo">Number</div>
            <div class="text-secondary fs-12 ticketDesc">Description</div>
            <div class="ml-auto">
              <input class="form-control bt-input text-secondary fs-12" [(ngModel)]="searchValue" name="search-ag-grid"
                placeholder="Search" type="text">
            </div>
          </div>
          <div *ngIf='ticketDescRowLength > 0' class="height_35 bt-suggestion-margin">
            <ag-grid-angular class="ag-theme-balham" style="height:350px;" [headerHeight]="0" [pagination]="true"
              [rowData]="ticketDescRow" [columnDefs]="ticketDescColumns" (gridReady)="onGridReady($event)"
              (firstDataRendered)="onFirstDataRendered($event)" [quickFilterText]="searchValue"
              [paginationAutoPageSize]="true">
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>